import React from 'react';
import {
  arrayOf, bool, func, node, oneOfType, string
} from 'prop-types';
import classNames from 'classnames';

const Footer = (props) => {
  const {
    className,
    children,
    onTriggerClick,
    scrollToBottom,
    triggerFor,
    hideTopBorder
  } = props;
  const classes = classNames(
    'content-card__footer',
    className,
    {
      'content-card__footer--no-top-border': hideTopBorder
    }
  );

  const trigger = (scrollToBottom && !triggerFor) ? 'default-overlay' : triggerFor;

  const triggerClick = (event) => {
    if (trigger) {
      onTriggerClick(event, trigger, scrollToBottom);
    }
  };

  return (
    <div className={classes}>
      {
        trigger
          ? (
            <button
              type="button"
              className="bttn--inline"
              onClick={(event) => triggerClick(event.target)}
            >
              { children }
            </button>
          )
          : children
      }
    </div>
  );
};

Footer.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node)
  ]).isRequired,
  className: string,
  onTriggerClick: func,
  scrollToBottom: bool,
  triggerFor: string,
  hideTopBorder: bool
};

Footer.defaultProps = {
  className: null,
  onTriggerClick: null,
  scrollToBottom: false,
  triggerFor: null,
  hideTopBorder: false
};

export default Footer;
